import React from "react";
import { Text } from "basis";

export const Footer = ({ sessionID = "" }) => (
  <>
    <Text textStyle="subtitle2">
      If you are having issues with this payment, please contact the retailer
    </Text>
    <Text textStyle="subtitle2">
      and quote the reference number <strong>{sessionID}</strong>.
    </Text>
  </>
);
